import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createBlock as _createBlock, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a09cf68e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "time" }
const _hoisted_2 = { class: "date" }
const _hoisted_3 = { class: "year" }
const _hoisted_4 = { class: "md-preview" }
const _hoisted_5 = {
  key: 0,
  class: "demo-image__preview"
}
const _hoisted_6 = { class: "xx" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_videoPlay = _resolveComponent("videoPlay")!
  const _component_v_md_preview = _resolveComponent("v-md-preview")!
  const _component_ArrowDownBold = _resolveComponent("ArrowDownBold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, { class: "mylife gWidth animated animate__fadeIn" }, {
    default: _withCtx(() => [
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.article, (item) => {
          return (_openBlock(), _createElementBlock("li", {
            key: item._id
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("b", null, _toDisplayString(item.time.slice(8, 10)), 1),
                _createElementVNode("b", null, _toDisplayString(item.time.slice(5, 7)) + "月", 1)
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("b", null, _toDisplayString(item.time.slice(0, 4)), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_router_link, {
                target: "_blank",
                to: `/details?id=${item._id}`,
                class: "tagss"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("● " + _toDisplayString(item.title), 1)
                ]),
                _: 2
              }, 1032, ["to"]),
              (item.coverPhoto && !item.Abstract)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_el_image, {
                      style: {"width":"200px","height":"200px"},
                      src: item.coverPhoto,
                      "preview-src-list": [item.coverPhoto],
                      "initial-index": 4,
                      fit: "cover"
                    }, null, 8, ["src", "preview-src-list"])
                  ]))
                : _createCommentVNode("", true),
              (item.Abstract && item.coverPhoto)
                ? (_openBlock(), _createBlock(_component_videoPlay, _normalizeProps(_mergeProps({ key: 1 }, _ctx.Goptions(item.Abstract, item.coverPhoto))), null, 16))
                : _createCommentVNode("", true),
              _createVNode(_component_v_md_preview, {
                text: item.content
              }, null, 8, ["text"]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_router_link, {
                  target: "_blank",
                  to: `/details?id=${item._id}`,
                  class: "tags"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("● " + _toDisplayString(item.title), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]),
                _createVNode(_component_router_link, {
                  target: "_blank",
                  to: `/details?id=${item._id}`,
                  type: "info",
                  class: "times"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.time.slice(0, 10)), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]),
                _createElementVNode("div", null, [
                  _createVNode(_component_router_link, {
                    target: "_blank",
                    to: `/details?id=${item._id}`,
                    type: "info"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("阅读(" + _toDisplayString(item.read) + ")", 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  _hoisted_7,
                  _createVNode(_component_router_link, {
                    target: "_blank",
                    to: `/details?id=${item._id}`,
                    type: "info"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("评论(" + _toDisplayString(item.comments_s.length) + ")", 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ])
              ])
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("p", {
        class: "loadmore cp",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scrollF && _ctx.scrollF(...args)))
      }, [
        (_ctx.isRefreshBool)
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, "加载更多"))
          : (_openBlock(), _createElementBlock("span", _hoisted_9, "已加载全部内容!!")),
        (_ctx.isRefreshBool)
          ? (_openBlock(), _createBlock(_component_el_icon, {
              key: 2,
              size: 14,
              color: `#69737b`
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ArrowDownBold),
                _createVNode(_component_ArrowDownBold)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}